import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import useWindowSize from "../../../../../common/hooks/useWindowSize";
import { LeafDonutWithIcon } from "../../../../../common/leaf/LeafDonutWithIcon/LeafDonutWithIcon";
import breakpoints from "../../../../../common/scss/breakpoints.module.scss";
import defaultAwardContent from "../../../../../content/awardLabels";
import "./PVRequirementTile.scss";

interface Props {
  percent: number;
  met: boolean;
  label?: ReactNode;
}

export const PVRequirementTile = ({ percent, met, label = "PV Requirement" }: Props) => {
  const { width } = useWindowSize();
  const isMobile = Number(width) <= Number(breakpoints["tabletSmall"]);
  const { t } = useTranslation(["awardLabels"]);
  const noDataLabel = t(
    "awardLabels.no-data-available",
    defaultAwardContent.awardLabels["no-data-available"] as string,
  );
  const isNoData = label === "--";

  return (
    <div className="pv-requirement-tile">
      <div className="pv-requirement-tile__donut">
        <LeafDonutWithIcon percentage={percent} isMet={met} size={isMobile ? "sm" : "md"} variant="progress" />
      </div>
      <div className="pv-requirement-tile__content">
        <div className="pv-requirement-tile__label" {...(isNoData ? { role: "text", "aria-label": noDataLabel } : {})}>
          {isNoData ? <span aria-hidden="true">{label}</span> : label}
        </div>
      </div>
    </div>
  );
};
